import React__default from 'react';
import clsx from 'clsx';
import HTMLReactParser from 'html-react-parser';
import sanitizeHtml from 'sanitize-html';

var SanitizeHtml = function (_a) {
    var html = _a.html, id = _a.id, className = _a.className, _b = _a.testId, testId = _b === void 0 ? "SanitizeHtml" : _b, parseOptions = _a.parseOptions, sanitizeOptions = _a.sanitizeOptions;
    return (React__default.createElement("div", { id: id, "data-testid": testId, className: clsx("SanitizeHtml", className) }, HTMLReactParser(sanitizeHtml(html, sanitizeOptions), parseOptions)));
};

export { SanitizeHtml as default };
//# sourceMappingURL=index.js.map
